/* Navigation lifecycle is local to the global header roots. */
(() => {
  if (window.gffGlobalsInitialized) return;
  window.gffGlobalsInitialized = true;
  const cleanups = new WeakMap();
  const desktopMedia = window.matchMedia('(min-width:1180px)');
  function mount(root) {
    cleanups.get(root)?.();
    const controller = new AbortController();
    const {signal} = controller;
    const listen = (node,type,handler) => node?.addEventListener(type,handler,{signal});
    const mobile = root.dataset.gffNav === 'm';
    const toggle = root.querySelector('[data-gff-menu-toggle]');
    const drawer = root.querySelector('[data-gff-drawer]');
    const identity = root.closest('[id]')?.id || ('gff-nav-'+root.dataset.gffNav);
    let open = '';
    const setDesktop = value => {
      open = value;
      root.querySelectorAll('[data-gff-menu]').forEach(button => button.setAttribute('aria-expanded',String(button.dataset.gffMenu === value)));
      root.querySelectorAll('[data-gff-panel]').forEach(panel => panel.hidden = panel.dataset.gffPanel !== value);
    };
    const setMobile = value => {
      if (!drawer) return;
      drawer.hidden = !value;
      toggle.setAttribute('aria-expanded',String(value));
      toggle.setAttribute('aria-label',value ? 'Close menu' : 'Open menu');
      toggle.querySelector('path')?.setAttribute('d',value ? 'M6 6l12 12M18 6L6 18' : 'M3 6h18M3 12h18M3 18h18');
    };
    const setTab = value => {
      root.querySelectorAll('[data-gff-tab]').forEach(button => button.setAttribute('aria-selected',String(button.dataset.gffTab === value)));
      root.querySelectorAll('[data-gff-tab-panel]').forEach(panel => panel.hidden = panel.dataset.gffTabPanel !== value);
    };
    const close = (restoreFocus=false) => {
      if (mobile) { const wasOpen = drawer && !drawer.hidden; setMobile(false); if(wasOpen && restoreFocus) toggle.focus(); }
      else { const active = root.querySelector('[data-gff-menu][aria-expanded=true]'); setDesktop(''); if(restoreFocus) active?.focus(); }
    };
    if (mobile) {
      setMobile(false);setTab('shop');
      drawer.id=identity+'-drawer';toggle.setAttribute('aria-controls',drawer.id);
      const tabs = [...root.querySelectorAll('[data-gff-tab]')];
      tabs[0]?.parentElement.setAttribute('role','tablist');
      tabs.forEach(button => {
        button.setAttribute('role','tab');
        const panel=root.querySelector('[data-gff-tab-panel="'+button.dataset.gffTab+'"]');
        panel.id=identity+'-'+button.dataset.gffTab;panel.setAttribute('role','tabpanel');button.setAttribute('aria-controls',panel.id);
        listen(button,'click',() => setTab(button.dataset.gffTab));
        listen(button,'keydown',event => { if(!['ArrowLeft','ArrowRight'].includes(event.key)) return; event.preventDefault(); const next=tabs.find(tab=>tab!==button);setTab(next.dataset.gffTab);next.focus(); });
      });
      listen(toggle,'click',() => setMobile(drawer.hidden));
      listen(drawer,'click',event => {if(event.target.closest('a'))close();});
      listen(root,'keydown',event => {
        if(event.key!=='Tab'||drawer.hidden)return;
        const controls=[...root.querySelectorAll('button,a[href],input')].filter(el=>el.getClientRects().length);
        const first=controls[0],last=controls.at(-1);
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
        else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
      });
    } else {
      setDesktop('');
      root.querySelectorAll('[data-gff-menu]').forEach(button => {
        const panel=root.querySelector('[data-gff-panel="'+button.dataset.gffMenu+'"]');
        panel.id=identity+'-'+button.dataset.gffMenu;button.setAttribute('aria-controls',panel.id);
        listen(button,'mouseenter',() => setDesktop(button.dataset.gffMenu));
        listen(button,'click',() => setDesktop(button.dataset.gffMenu));
        listen(button,'keydown',event=>{if(event.key==='ArrowDown'){event.preventDefault();setDesktop(button.dataset.gffMenu);root.querySelector('[data-gff-panel="'+button.dataset.gffMenu+'"] a')?.focus();}});
      });
      listen(root,'mouseleave',() => close());
      listen(root,'focusout',event => {if(!root.contains(event.relatedTarget))close();});
      listen(document,'click',event=>{if(!root.contains(event.target))close();});
    }
    listen(document,'keydown',event=>{if(event.key==='Escape')close(true);});
    listen(document,'shopify:block:select',event=>{
      if(!root.getClientRects().length)return;
      const blockId=event.detail?.blockId;
      const target=blockId ? [...root.querySelectorAll('[data-pagesmith-block]')].find(el=>el.dataset.pagesmithBlock===blockId) : event.target;
      if(!target||!root.contains(target))return;
      if(mobile){setMobile(true);const panel=target.closest('[data-gff-tab-panel]');if(panel)setTab(panel.dataset.gffTabPanel);}
      else {const panel=target.closest('[data-gff-panel]');if(panel)setDesktop(panel.dataset.gffPanel);}
    });
    listen(desktopMedia,'change',() => close());
    cleanups.set(root,() => controller.abort());
  }
  function init(scope=document) {
    scope.querySelectorAll('[data-gff-nav]').forEach(mount);
    scope.querySelectorAll('[data-gff-signup]').forEach(form=>{
      if(form.dataset.gffBound)return;
      form.dataset.gffBound='true';
      form.addEventListener('submit',event=>{
        if(form.dataset.gffSignupStatus==='connected')return;
        event.preventDefault();
        if(!form.querySelector('input[type=email]').reportValidity())return;
        const message=form.parentElement.querySelector('[data-gff-signup-message]');
        if(message)message.hidden=false;
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-gff-nav]').forEach(root=>cleanups.get(root)?.()));
})();

(() => {
  if (window.GFFReviewVideos) return;
  window.GFFReviewVideos = true;

  function initialize(root = document) {
    root.querySelectorAll('[data-gff-review-carousel]').forEach((carousel) => {
      if (carousel.dataset.initialized) return;
      carousel.dataset.initialized = 'true';
      const track = carousel.querySelector('[data-gff-review-track]');
      const previous = carousel.querySelector('[data-gff-review-direction="-1"]');
      const next = carousel.querySelector('[data-gff-review-direction="1"]');
      const update = () => {
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      };
      const move = (direction) => {
        track.scrollBy({ left: direction * Math.max(170, track.clientWidth * .8), behavior: 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') {
          track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: 'smooth' });
        } else {
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      new ResizeObserver(update).observe(track);
      update();
    });
  }

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

/* Bring the existing navigation back on upward scrolling without cloning its controls. */
(() => {
  if (window.GFFReturningNavigation) return;
  window.GFFReturningNavigation = true;
  const originalHeights = new WeakMap();
  let previousY = window.scrollY;
  let scheduled = false;

  function setReturning(section, returning) {
    if (section.classList.contains('gff-navigation-returning') === returning) return;
    if (returning) {
      originalHeights.set(section, section.style.minHeight);
      section.style.minHeight = `${section.getBoundingClientRect().height}px`;
    } else {
      section.style.minHeight = originalHeights.get(section) || '';
    }
    section.classList.toggle('gff-navigation-returning', returning);
  }

  function update() {
    scheduled = false;
    const y = Math.max(0, window.scrollY);
    const delta = y - previousY;
    if (Math.abs(delta) < 6 && y > 0) return;
    document.querySelectorAll('[data-gff-nav]').forEach((navigation) => {
      const section = navigation.closest('.gff-navigation-section');
      if (!section) return;
      const visible = navigation.getClientRects().length > 0;
      const open = navigation.querySelector('[aria-expanded="true"]');
      const beyondHeader = y > navigation.offsetHeight;
      setReturning(section, visible && beyondHeader && (delta < 0 || Boolean(open)));
    });
    previousY = y;
  }

  window.addEventListener('scroll', () => {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });
  window.addEventListener('resize', () => {
    document.querySelectorAll('.gff-navigation-returning').forEach((section) => setReturning(section, false));
    previousY = window.scrollY;
  });
})();
